export default __webpack_public_path__ + "static/media/owner-icon.5ff90259.svg";